import { FieldPath, FieldValues } from 'react-hook-form';

// common
import { IControllerRenderProps } from 'common/SchemaForm/utils';
import { generateDisplayParts } from 'common/components/OperationCodeField/utils';
import OperationCodeFieldBase from 'common/components/OperationCodeField/OperationCodeFieldBase';

interface Props<T extends FieldValues = FieldValues, TName extends FieldPath<T> = FieldPath<T>>
  extends IControllerRenderProps<T, TName> {
  label?: React.ReactNode;
  required?: boolean;
}

const DynamicOperationCodeField = <
  T extends FieldValues = FieldValues,
  TName extends FieldPath<T> = FieldPath<T>,
>(
  props: Props<T, TName>
) => {
  const {
    label,
    field: { value },
    fieldState: { invalid },
    required = true,
  } = props;

  const displayParts = generateDisplayParts(value);

  return (
    <OperationCodeFieldBase
      label={label}
      required={required}
      invalid={invalid}
      displayParts={displayParts}
    />
  );
};

export default DynamicOperationCodeField;
